import React from 'react';
import TextTransformer from './components/TextTransformer';

function App() {
  return (
    <div className="App">
      <TextTransformer />
    </div>
  );
}

export default App;